import React, { useState } from 'react';
import { HStack, Button } from '@chakra-ui/react';
import { Hospital } from '../../types';

interface HospitalCardActionsProps {
  hospital: Hospital;
  onStatusUpdate: (id: string, status: Hospital['status']) => void;
  onReprocess?: (hospitalId: string) => void;
}

const HospitalCardActions: React.FC<HospitalCardActionsProps> = ({
  hospital,
  onStatusUpdate,
  onReprocess
}) => {
  const [reprocessing, setReprocessing] = useState(false);

  const handleReprocess = async () => {
    if (!onReprocess) return;
    setReprocessing(true);
    try {
      await onReprocess(hospital._id);
    } catch (error) {
      console.error('Failed to reprocess hospital:', error);
    } finally {
      setReprocessing(false);
    }
  };

  switch (hospital.status) {
    case 'doubtful':
      return (
        <HStack spacing={2} mt={4}>
          <Button
            size="sm"
            colorScheme="red"
            onClick={() => onStatusUpdate(hospital._id, 'matched')}
          >
            Mark as Matched
          </Button>
          <Button
            size="sm"
            colorScheme="green"
            onClick={() => onStatusUpdate(hospital._id, 'new_hospital')}
          >
            Mark as New
          </Button>
        </HStack>
      );
    case 'matched':
      return (
        <Button
          size="sm"
          colorScheme="green"
          mt={4}
          onClick={() => onStatusUpdate(hospital._id, 'new_hospital')}
        >
          Mark as New
        </Button>
      );
    case 'new_hospital':
      return (
        <HStack spacing={2} mt={4}>
          <Button
            mt={4}
            size="sm"
            colorScheme="red"
            onClick={() => onStatusUpdate(hospital._id, 'matched')}
          >
            Mark as Matched
          </Button>
          <Button
            size="sm"
            colorScheme="green"
            mt={4}
            onClick={() => onStatusUpdate(hospital._id, 'approved')}
          >
            Final Approve
          </Button>
        </HStack>
      );
    case 'rejected':
      return onReprocess ? (
        <Button
          size="sm"
          colorScheme="blue"
          mt={4}
          isLoading={reprocessing}
          onClick={handleReprocess}
        >
          Reprocess
        </Button>
      ) : null;
    default:
      return null;
  }
};

export default HospitalCardActions;